import { useRef } from 'react';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import './title.css';

const Title = ({ title, isRight = false }) => {
    const titleRef = useRef(null);
    useScrollAnimation([titleRef]);

    return (
        <div ref={titleRef} className="title-main-div animate-on-scroll">
            <p className={isRight ? 'title-text' : 'title-text-right'}>{title}</p>
            <div className={isRight ? 'text-line-separator-right' : 'text-line-separator'}></div>
        </div>
    );
};

export default Title;
